import { render } from "./McpAuditList.vue?vue&type=template&id=853d376a&scoped=true"
import script from "./McpAuditList.vue?vue&type=script&lang=js"
export * from "./McpAuditList.vue?vue&type=script&lang=js"

import "./McpAuditList.vue?vue&type=style&index=0&id=853d376a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-853d376a"]])

export default __exports__